var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masked-input',{staticClass:"ui-masked-input",class:{ 'ui-masked-input--error': _vm.error, 'ui-masked-input--disabled': _vm.disabled },attrs:{"value":_vm.value,"id":_vm.id,"placeholder":_vm.placeholder,"mask":{ pattern: _vm.mask },"disabled":_vm.disabled,"type":_vm.type},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":function($event){return _vm.$emit('blur')}}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/public/forms/fields/UiMaskedInput.vue?vue&type=template&id=187994c0&
// module id = 1099
// module chunks = 0